import { ThemeContext } from '@/theme/ThemeProvider';
import { useContext } from 'react';
import styled from 'styled-components';

const MActiveSvg = () => {
  const { theme } = useContext(ThemeContext);
  const fill = theme.COLORS.greenText;

  return (
    <>
      <FirstLayer
        width="88"
        height="88"
        viewBox="0 0 88 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M83.5213 43.0636H87.9998C87.7968 32.0348 83.4294 21.4911 75.7746 13.5492L72.608 16.716C72.2377 17.077 71.6448 17.0696 71.2839 16.6995C70.9292 16.3358 70.9292 15.7556 71.2839 15.3921L74.4506 12.2253C66.5087 4.57048 55.9651 0.203203 44.9364 0V4.47853C44.9364 4.99562 44.5171 5.41494 44 5.41494C43.4829 5.41494 43.0636 4.99562 43.0636 4.47853V0C32.0349 0.203015 21.4913 4.57048 13.5494 12.2253L16.7161 15.3921C17.0863 15.7532 17.0939 16.3459 16.7328 16.7162C16.3717 17.0865 15.7787 17.0939 15.4085 16.7328C15.4029 16.7272 15.3973 16.7216 15.3918 16.716L12.2252 13.5492C4.57042 21.4911 0.203202 32.0348 0 43.0636H4.47851C4.99559 43.0636 5.41492 43.4829 5.41492 44C5.41492 44.5171 4.99559 44.9364 4.47851 44.9364H0C0.203014 55.9652 4.57042 66.5089 12.2252 74.4508L15.3918 71.284C15.7529 70.9138 16.3456 70.9061 16.7159 71.2672C17.0863 71.6281 17.0939 72.221 16.7328 72.5913C16.7274 72.5969 16.7217 72.6025 16.7161 72.6079L13.5494 75.7747C21.4913 83.4295 32.0349 87.7968 43.0636 88V83.5215C43.0636 83.0044 43.4829 82.5851 44 82.5851C44.5171 82.5851 44.9364 83.0044 44.9364 83.5215V88C55.9651 87.797 66.5087 83.4295 74.4506 75.7747L71.2839 72.6079C70.9137 72.2468 70.9062 71.6539 71.2675 71.2836C71.6287 70.9134 72.2214 70.9061 72.5915 71.2672C72.5971 71.2726 72.6027 71.2782 72.6082 71.2838L75.7748 74.4506C83.4296 66.5085 87.7968 55.965 88 44.9362H83.5215C83.0044 44.9362 82.5851 44.5169 82.5851 43.9998C82.5851 43.4827 83.0042 43.0636 83.5213 43.0636ZM43.9998 81.1758C23.5012 81.1758 6.8242 64.4987 6.8242 44C6.8242 23.5013 23.5012 6.82423 43.9998 6.82423C64.4985 6.82423 81.1754 23.5013 81.1754 44C81.1754 64.4987 64.4985 81.1758 43.9998 81.1758Z"
          fill={fill}
        />
      </FirstLayer>

      <SecondLayer
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.0001 0.696777C16.5341 0.696777 0.697266 16.5337 0.697266 35.9997C0.697266 55.4658 16.5341 71.3026 36.0001 71.3026C55.466 71.3026 71.3028 55.4658 71.3028 35.9997C71.3028 16.5337 55.466 0.696777 36.0001 0.696777ZM36.0001 67.9315C18.3929 67.9315 4.06835 53.607 4.06835 35.9997C4.06835 18.3924 18.3929 4.06788 36.0001 4.06788C53.6073 4.06788 67.9318 18.3924 67.9318 35.9997C67.9318 53.607 53.6073 67.9315 36.0001 67.9315Z"
          fill={fill}
        />
      </SecondLayer>

      <ThirdLayer
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.9998 0.940918C14.4253 0.940918 0.940918 14.4253 0.940918 30.9999C0.940918 47.5745 14.4253 61.0589 30.9998 61.0589C47.5743 61.0589 61.0587 47.5745 61.0587 30.9999C61.0587 14.4253 47.5743 0.940918 30.9998 0.940918Z"
          fill={fill}
        />
      </ThirdLayer>
    </>
  );
};

export default MActiveSvg;

const FirstLayer = styled.svg`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
`;

const SecondLayer = styled.svg`
  position: absolute;
  left: 9.88%;
  right: 9.88%;
  top: 9.88%;
  bottom: 9.88%;
`;

const ThirdLayer = styled.svg`
  position: absolute;
  left: 15.84%;
  right: 15.84%;
  top: 15.84%;
  bottom: 15.84%;
`;
